import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useMarkets = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useMarketsQuery = (filter) =>
    useQuery({
      queryKey: ['getMarketsQuery', filter],
      queryFn: ({ queryKey }) => api.post('market/overview', { filter: queryKey[1] }),
      staleTime: 60 * 1000,
    })

  const useMarketMetadataQuery = () =>
    useQuery({ queryKey: ['getMarketMetadataQuery'], queryFn: () => api.post('market/metadata') })

  const createMarketMutation = useMutation({
    mutationKey: ['createMarketMutation'],
    mutationFn: (market) => {
      api.post('market/create', market)
    },
  })

  const updateMarketMutation = useMutation({
    mutationKey: ['updateMarketMutation'],
    mutationFn: (market) => api.post('market/update', market),
  })

  return {
    useMarketsQuery,
    useMarketMetadataQuery,
    createMarketMutation,
    updateMarketMutation,
  }
}
